import { render, staticRenderFns } from "./alertExpired.vue?vue&type=template&id=50663b03&"
import script from "./alertExpired.vue?vue&type=script&lang=js&"
export * from "./alertExpired.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports